<div class="flex flex-col gap-16 pin-container pin-background">
  <div class="flex flex-col gap-6 md:gap-15">
    <!-- Header container -->
    <div class="container">
      <pin-new-header [type]="isRegistrationPage ? 'registration' : 'new_public'" customClass="bg-transparent!" class="flex justify-center"></pin-new-header>
    </div>

    <div class="flex flex-row justify-center container">
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- Footer container -->
  <div class="footer--main">
    <pin-footer type="new_public"></pin-footer>
  </div>
</div>
